import React, { useState, useEffect } from "react";

import ArrowIcon from "../../../../icons/arrow-icon";
import FeesIcon from "../../../../icons/income-fees-icon";
import GiftIncomeIcon from "../../../../icons/gifts-income-icon";
import MisIncomesIcon from "../../../../icons/mis-icomes-icon";
import ProjectIncomesIcon from "../../../../icons/projects-income-icon";
import AcademicIncomeIcon from "../../../../icons/academic-income-icon";

import db from "../../../../services/query";
import lbl from "../../../../data/Labels.json";

const RevenuesTabs = ({ handleCurrentTab, currentTab }) => {
  const [tabs, setTabs] = useState([]);

  useEffect(async () => {
    const ac = new AbortController();

    await db.getAll("revenues/types").then(({ data }) => {
      setTabs(data.data);
    });

    return () => ac.abort();
  }, []);

  const renderIcon = (name) => {
    switch (name) {
      case "Students Fee":
        return <FeesIcon />;
      case "Grants":
        return <ProjectIncomesIcon />;
      case "Academic Support":
        return <AcademicIncomeIcon />;
      case "Gifts":
        return <GiftIncomeIcon />;
      case "Misc Revenues":
        return <MisIncomesIcon />;
      default:
        return null;
    }
  };
  return (
    <div className="site-tab-items">
      <button>
        <i>
          <ArrowIcon />
        </i>
        <span>{lbl.Revenues}</span>
      </button>
      <ul>
        {tabs.map((tab) => (
          <li
            key={tab.id}
            onClick={() => handleCurrentTab(tab, "revenues")}
            className={`${currentTab?.name_en === tab?.name_en && "active"}`}
          >
            <i>{renderIcon(tab.name_en)}</i>
            <span>{tab.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RevenuesTabs;
